var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._b({attrs:{"width":_vm.width,"value":_vm.isOpen,"fullscreen":_vm.fullscreen,"hide-overlay":_vm.hideOverlay,"persistent":!_vm.closeOnClickOutside},on:{"click":function($event){return _vm.close()},"click:outside":function($event){_vm.closeOnClickOutside ? _vm.close() : ''}}},'v-dialog',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }